var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.443,
    height: 19.992,
    viewBox: "0 0 27.443 19.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Passwordhide",
    transform: "translate(0.323 0.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M264.648,348.562a.537.537,0,1,0-.76.76,3.223,3.223,0,1,1-4.558,4.558.537.537,0,1,0-.76.76,4.3,4.3,0,1,0,6.078-6.078Zm0,0",
    transform: "translate(-247.714 -341.931)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M247.047,332.07A4.256,4.256,0,0,0,242,336.294a4.2,4.2,0,0,0,.075.749.538.538,0,0,0,.528.444.465.465,0,0,0,.094-.009.538.538,0,0,0,.435-.622,3.114,3.114,0,0,1-.058-.562,3.184,3.184,0,0,1,3.786-3.166.537.537,0,1,0,.187-1.057Zm0,0",
    transform: "translate(-233.404 -326.624)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M233.018,312.019a26.107,26.107,0,0,0-7.037-5.614.538.538,0,0,0-.493.955,25.244,25.244,0,0,1,6.4,5.005c-1.281,1.387-6.322,6.447-11.635,6.447a12.386,12.386,0,0,1-5.4-1.295.537.537,0,0,0-.466.967,13.437,13.437,0,0,0,5.869,1.4c6.62,0,12.52-6.882,12.768-7.175a.537.537,0,0,0,0-.694Zm0,0",
    transform: "translate(-206.356 -302.696)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M130.419,284.615a11.093,11.093,0,0,0-3.526-.619c-6.62,0-12.52,6.881-12.768,7.175a.537.537,0,0,0-.03.654,19.942,19.942,0,0,0,4.929,4.673.534.534,0,0,0,.744-.152.536.536,0,0,0-.151-.743,19.653,19.653,0,0,1-4.387-4.057c1.237-1.343,6.311-6.476,11.663-6.476a10.058,10.058,0,0,1,3.183.562.53.53,0,0,0,.68-.337.536.536,0,0,0-.337-.68Zm0,0",
    transform: "translate(-113.999 -281.848)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M181.182,252.164a.538.538,0,0,0-.76,0l-18.267,18.267a.537.537,0,0,0,.76.76l18.267-18.267a.537.537,0,0,0,0-.76Zm0,0",
    transform: "translate(-157.775 -252.007)",
    fill: "#6b6b6b",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.4d87085d2e93ec373285aeac32717bbf.svg";
export { ForwardRef as ReactComponent };